import React from 'react'
import withMenuToggle from '../common/withMenuToggle'
import classnames from 'classnames'
import Nav from './Nav'
import NavItem from './NavItem'

const Header = ({ showMenu, toggleMenu, className }) => (
  <header
    className={classnames({
      header: true,
      [className]: className,
      // When opening menu, force light mode
      'header--light': showMenu,
      'header--light-filled': showMenu
    })}
  >
    <div className="container">
      <a href="/" className="logo">
        Playvs
      </a>
      {showMenu && <Nav />}
      <nav className="nav-desktop">
        <ul>
          <NavItem path="https://app.playvs.com/login" className="btn btn__small btn__reverse">
            Log In
          </NavItem>
          <NavItem path="https://app.playvs.com/sign-up" className="btn btn__small">
            Sign up
          </NavItem>
        </ul>
      </nav>
      <button className={classnames({ 'btn-nav': true, 'btn-nav--active': showMenu })} onClick={toggleMenu}>
        <div />
      </button>
    </div>
  </header>
)

export default withMenuToggle(Header)



// WEBPACK FOOTER //
// ./src/common/ui/components/Header.js